<div class="home_shortcuts_container">
  <h3>Accesos directos</h3>
  <div class="home_shortcuts" *ngIf="data.length > 0">
    <ng-container *ngFor="let item of data">
      <div class="shortcut">
        <a *ngIf="item.ExternalUrl == true" [href]="item.Url" (click)="TrackBanner(item.IdElement)"
          [attr.target]="item.UrlOpenNew ? '_blank' : null" [attr.rel]="item.UrlOpenNew ? 'noopener noreferrer' : null"
          [attr.title]="item.UrlTitle">
          <img [src]="item.ImageFile.FileUri" alt="{{item.Title}}">
        </a>
        <a *ngIf="item.ExternalUrl == false" [attr.href]="item.Url" (click)="TrackBanner(item.IdElement)"
          [attr.target]="item.UrlOpenNew ? '_blank' : null" [attr.title]="item.UrlTitle">
          <img [src]="item.ImageFile.FileUri" alt="{{item.Title}}">
        </a>
      </div>
    </ng-container>
  </div>
</div>